export const APP_CONTAINER_ID = "zing-app-container";
